<template>
  <div class="vertical-tabs--container" vertical>
    <asc-tab v-model="tab" vertical @tabChange="handleTabChange">
      <asc-tab-title
        v-for="(item, index) in tabs"
        :key="item.title + index"
        :title="item.title"
        vertical
      />
    </asc-tab>
    <asc-tab-body
      :value="tab"
      no-padding
      class="asc-airline-mgmt-template-tab-body"
    >
      <asc-tab-item>
        <asc-airline-mgmt-wrapper
          :values="onboardingValues"
          :add-airline="addAirline"
          :on-open-airline="onOpenAirline"
        ></asc-airline-mgmt-wrapper>
      </asc-tab-item>
      <asc-tab-item>
        <asc-airline-agreement-wrapper
          :values="agreementValues"
          :add-agreement="addAgreement"
        >
        </asc-airline-agreement-wrapper>
      </asc-tab-item>
    </asc-tab-body>
  </div>
</template>

<script>
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'
import AscAirlineAgreementWrapper from '../organisms/AscAirlineAgreementWrapper.vue'
import AscAirlineMgmtWrapper from '../organisms/AscAirlineMgmtWrapper.vue'

export default {
  name: 'AscAirlineMgmtTemplate',

  components: {
    AscTabBody,
    AscTabItem,
    AscAirlineMgmtWrapper,
    AscTab,
    AscTabTitle,
    AscAirlineAgreementWrapper,
  },

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    onboardingValues: {
      type: Array,
      default: () => [],
    },
    addAirline: {
      type: Function,
      default: () => {},
    },
    onOpenAirline: {
      type: Function,
      default: () => {},
    },
    agreementValues: {
      type: Array,
      default: () => [],
    },
    addAgreement: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      tab: null,
    }
  },

  methods: {
    handleTabChange(tab) {
      this.$emit('tabChange', tab)
    },
  },
}
</script>

<style lang="scss">
.asc-airline-mgmt-template-tab-body {
  width: 100%;
}

.vertical-tabs--container {
  display: flex;
  flex-flow: row;
  min-height: 397px;

  .asc-vertical-tabs {
    width: 200px;

    .v-tabs-bar {
      width: 200px;
    }

    .asc-accent-button {
      background-color: $gray-100 !important;
      border: none;
      align-self: flex-end;
      width: 100%;
    }

    .asc-accent-button-container .asc-accent-button--accent .v-btn__content {
      color: $accent-700;
      text-transform: none;
      font-weight: normal;
    }
  }

  .asc-tab__content--primary,
  .asc-tab__content--secondary {
    width: 100%;
  }
}
</style>
